var map = {
	"./bear-svgrepo-com.svg": 4209,
	"./crab-svgrepo-com.svg": 9525,
	"./crocodile-svgrepo-com.svg": 9107,
	"./cute-animals-svgrepo-com.svg": 5438,
	"./dinosaur-svgrepo-com.svg": 9258,
	"./elk-svgrepo-com.svg": 5049,
	"./fox-svgrepo-com.svg": 4232,
	"./hedgehog-svgrepo-com.svg": 6936,
	"./jellyfish-svgrepo-com.svg": 1125,
	"./lion-svgrepo-com.svg": 8877,
	"./penguin-svgrepo-com.svg": 3315,
	"./polar-bear-svgrepo-com.svg": 6712,
	"./rabbit-svgrepo-com.svg": 4311,
	"./raccoon-svgrepo-com.svg": 9136,
	"./shrimp-svgrepo-com.svg": 2130,
	"./squirrel-svgrepo-com.svg": 834,
	"./the-cow-svgrepo-com.svg": 2560,
	"./turtle-svgrepo-com.svg": 2641,
	"./whale-svgrepo-com.svg": 820,
	"./wild-boar-svgrepo-com.svg": 3450,
	"assets/svgs/bear-svgrepo-com.svg": 4209,
	"assets/svgs/crab-svgrepo-com.svg": 9525,
	"assets/svgs/crocodile-svgrepo-com.svg": 9107,
	"assets/svgs/cute-animals-svgrepo-com.svg": 5438,
	"assets/svgs/dinosaur-svgrepo-com.svg": 9258,
	"assets/svgs/elk-svgrepo-com.svg": 5049,
	"assets/svgs/fox-svgrepo-com.svg": 4232,
	"assets/svgs/hedgehog-svgrepo-com.svg": 6936,
	"assets/svgs/jellyfish-svgrepo-com.svg": 1125,
	"assets/svgs/lion-svgrepo-com.svg": 8877,
	"assets/svgs/penguin-svgrepo-com.svg": 3315,
	"assets/svgs/polar-bear-svgrepo-com.svg": 6712,
	"assets/svgs/rabbit-svgrepo-com.svg": 4311,
	"assets/svgs/raccoon-svgrepo-com.svg": 9136,
	"assets/svgs/shrimp-svgrepo-com.svg": 2130,
	"assets/svgs/squirrel-svgrepo-com.svg": 834,
	"assets/svgs/the-cow-svgrepo-com.svg": 2560,
	"assets/svgs/turtle-svgrepo-com.svg": 2641,
	"assets/svgs/whale-svgrepo-com.svg": 820,
	"assets/svgs/wild-boar-svgrepo-com.svg": 3450
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2820;